module.exports = __webpack_public_path__ + "ms.4360ca11d0c40a7bfc42.svg";


//////////////////
// WEBPACK FOOTER
// E:/proj/news12/zb-n12/scadmin/client/src/assets/fonts/flag-icon-css/flags/1x1/ms.svg
// module id = ../../../../../src/assets/fonts/flag-icon-css/flags/1x1/ms.svg
// module chunks = styles